// @flow

import { Field } from 'react-form';
import { TextArea, Form } from 'semantic-ui-react';
import React from 'react';

type Props = {
  onChange: (val: string) => void,
  field: string,
  validate: Function
};

const CustomTextArea = (props: Props) => {
  const { onChange, field, validate, ...rest } = props;

  return (
    <Field validate={validate} field={field}>
      {fieldApi => {
        const { value, setValue } = fieldApi;

        return (
          <Form as="div">
            <TextArea
              {...rest}
              value={value || ''}
              onChange={e => {
                setValue(e.target.value);

                if (onChange) {
                  onChange(e.target.value);
                }
              }}
            />
          </Form>
        );
      }}
    </Field>
  );
};

export default CustomTextArea;



// WEBPACK FOOTER //
// ./src/forms/TextArea.js